// 服务端、客户端都会走这里
export default defineNuxtRouteMiddleware(async (to, from) => {
  // eslint-disable-next-line no-undef
  const token = useCookie('voo-token');
  const passAuth = token.value || to.query.token;

  // 黑五活动页重定向：/bfcm_activity -> /black-friday-deals
  if (to.path === '/bfcm_activity') {
    return navigateTo('/black-friday-deals', { replace: true });
  }

  // 119列表页重定向到新品专题页
  if (to.path.startsWith('/goods-list/119')) {
    return navigateTo('/collections/new-eyeglasses', { replace: true, redirectCode: 301 });
  }

  if (
    to.path.startsWith('/koc-program') ||
    to.path.startsWith('/kol-program') ||
    to.path.startsWith('/influencer')
  ) {
    return navigateTo('/affiliateProgram', { replace: true });
  }

  // 用户鉴权
  if (
    (to.path.startsWith('/account/') || ['/track-order', '/payment'].includes(to.path)) &&
    !passAuth
  ) {
    return navigateTo({
      path: '/register',
      query: { ...to.query, redirect: to.path },
    });
  } else if (to.name === 'register' && passAuth) {
    return navigateTo('/');
  }
});
